import api from './api';
import {
    CmsPageResponse,
    SingleCmsPageResponse,
    CmsPageAttributes
} from '../types/cms';

export const getCmsPages = async (params?: {
    page?: number;
    limit?: number;
    search?: string;
    isActive?: boolean;
}): Promise<CmsPageResponse> => {
    const response = await api.get('cms/pages', { params });
    return response.data;
};

export const getCmsPageBySlug = async (slug: string): Promise<SingleCmsPageResponse> => {
    const response = await api.get(`cms/pages/${slug}`);
    return response.data;
};

export const updateCmsPage = async (slug: string, data: Partial<CmsPageAttributes>): Promise<SingleCmsPageResponse> => {
    const response = await api.put(`cms/pages/${slug}`, data);
    return response.data;
};

export const toggleCmsPageActive = async (slug: string): Promise<SingleCmsPageResponse> => {
    const response = await api.patch(`cms/pages/${slug}/toggle-active`);
    return response.data;
};
